<template>
  <div class="tabbar flex flex-between">
    <template v-for="(v, i) in tabBarList">
      <div
        class="tab-item flex-1 text-center flex flex-column flex-center"
        :key="i"
        v-if="v.open"
        :class="{ active: activeTabBar === i }"
      >
        <div class="tab-icon">
          <img
            class="image"
            v-if="v.selectedIconpath"
            :src="activeTabBar === i ? v.selectedIconpath : v.iconPath"
          />
          <div class="no-bg" v-else></div>
        </div>
        <div class="tab-name">{{ v.hrefName }}</div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    tabBarList: {
      type: Array,
      default: () => []
    },
    activeTabBar: {
      type: Number,
      default: 0
    }
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.tabbar {
  position: absolute;
  margin: 0;
  padding: 0;
  left: 0;
  bottom: -49px;
  box-sizing: border-box;
  width: 100%;
  list-style: none;
  background-color: #fff;
  font-size: 16px;
  height: 49px;
  font-size: 11px;
  z-index: 99;

  // 手机端去掉
  width: 375px;
  left: 50%;
  transform: translateX(-50%);
  .tab-icon {
    .image {
      width: 20px;
      height: 20px;
    }
  }
  .active {
    .tab-name {
      color: #e50065;
    }
  }

  .no-bg {
    height: 20px;
    width: 20px;
    margin: 0 auto;
    background: #f0f0f0;
  }
}
</style>
